import script from "./NativeCloudPhonePreviewFrameView.vue?vue&type=script&setup=true&lang=js"
export * from "./NativeCloudPhonePreviewFrameView.vue?vue&type=script&setup=true&lang=js"

import "./NativeCloudPhonePreviewFrameView.vue?vue&type=style&index=0&id=d0ca9e64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0ca9e64"]])

export default __exports__